<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="custom-table content">
    <div class="custom-table-row">
      <div class="custom-table-col">
        <p-floatlabel variant="on">
          <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" [(ngModel)]="data" inputId="data" styleClass="w-full" [appendTo]="'body'" />
          <label for="data">Data do Lote</label>
        </p-floatlabel>
      </div>

      <div class="custom-table-col">
        <p-floatlabel variant="on">
          <input pInputText type="text" id="nome" [(ngModel)]="nome" class="w-full" />
          <label for="nome">Nome do Lote</label>
        </p-floatlabel>
      </div>
    </div>
  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>
